//#region IMPORT
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
/** Components */
import 'dayjs/locale/ko';
import useDelete from '../../../../hooks/useDeleteN';
import {
  useSearch1,
  useSearch2,
  useDelete1,
  useSave1,
  useSave2,
} from './HEA_BASIC_01_QUERY';
import MemberInfoModal from '../../../../Components/MemberInfoModal/MemberInfoModal';
/** Icons Import */
import HEA_BASIC_01 from './HEA_BASIC_01';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import { useSave } from '../../../../hooks/useSaveN';
import { HEA_BASIC_01_Schema } from './HEA_BASIC_01_Schema';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import {
  closeLoading as closeLoadingAction,
  showLoading as showLoadingAction,
} from '../../../../Reducer/LoadingReducer';
import { setFileFields } from '../../../../Reducer/FileFieldReducer';
import useFileUpload from '../../../../hooks/useFileUpload';
import dayjs from 'dayjs';
import ExcelJS from 'exceljs';
//#endregion

//#region 상수
// 화면 MENU_ID
const SCREEN_MENU_ID = 'HealthCheckup';
//#endregion

function HEA_BASIC_01F(props) {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, lanInfo, companyInfo } = useSelector(
    (state) => state.BaseInfo
  );
  const { previewUrl, previewFileName } = useSelector(
    (state) => state.fileField
  ); // 미리보기 상태관리
  const searchInfo = useSelector((state) => state.SearchInfo);
  const gridRef1 = useRef(); //일반건강진단 그리드
  const gridRef3 = useRef(); //엑셀 업로드 그리드
  const fileInputRef = useRef(null);

  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRows, setDeletedRowData1] = useState([]);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const currentRowIndexRef1 = useRef(null);

  // 파일 업로드 관련 상태
  const [fileModalToggle, setFileModalToggle] = useState(false);
  const [currentFileFieldType, setCurrentFileFieldType] =
    useState('hcCheckupFile'); // 'hcCheckupFile' or 'hcPostcareFile'

  // 모달 관련 상태
  const [modalToggle1, setModalToggle1] = useState(false);
  const rowClickData = useRef(null);
  const [excelData, setExcelData] = useState([]);
  //#endregion

  //#region 커스텀훅
  // 회사/거래처 선택 상태 관리 및 필수 여부 검증을 위한 Hook
  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ requireCompany: true, requireCust: true });

  // 검진표 첨부 파일용 useFileUpload
  const {
    SaveLogicPreview: SaveLogicPreviewCheckup,
    SaveLogicFile: SaveLogicFileCheckup,
    DeleteLogicFile: DeleteLogicFileCheckup,
  } = useFileUpload({
    oldFilePathField: 'hcCheckupAttachmentFilePath',
    newFileNameField: 'hcCheckupAttachmentSaveName',
    getTargetPath: () =>
      `HealthCheckup/${searchInfo.custCd}/HEA_BASIC_01/Checkup`,
  });

  // 사후관리조치 첨부 파일용 useFileUpload
  const {
    SaveLogicPreview: SaveLogicPreviewPostcare,
    SaveLogicFile: SaveLogicFilePostcare,
    DeleteLogicFile: DeleteLogicFilePostcare,
  } = useFileUpload({
    oldFilePathField: 'hcPostcareAttachmentFilePath',
    newFileNameField: 'hcPostcareAttachmentSaveName',
    getTargetPath: () =>
      `HealthCheckup/${searchInfo.custCd}/HEA_BASIC_01/PostCare`,
  });

  // 현재 선택된 파일 필드에 따라 적절한 함수 반환 (기존 호환성 유지)
  const SaveLogicPreview =
    currentFileFieldType === 'hcCheckupFile'
      ? SaveLogicPreviewCheckup
      : SaveLogicPreviewPostcare;
  // eslint-disable-next-line no-unused-vars
  const SaveLogicFile =
    currentFileFieldType === 'hcCheckupFile'
      ? SaveLogicFileCheckup
      : SaveLogicFilePostcare;
  const DeleteLogicFile =
    currentFileFieldType === 'hcCheckupFile'
      ? DeleteLogicFileCheckup
      : DeleteLogicFilePostcare;

  // 부분 갱신 처리 (성공한 데이터만 재조회, 실패한 데이터는 유지)
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.hcCd,
    getKeyFromResult: (result) => result.HC_CD,
  });

  // 파일 필드 타입별 필드명 반환 헬퍼 함수
  const getFileFields = (type) => {
    const isCheckup = type === 'hcCheckupFile';
    return {
      fileNameField: isCheckup
        ? 'hcCheckupAttachmentFileName'
        : 'hcPostcareAttachmentFileName',
      saveNameField: isCheckup
        ? 'hcCheckupAttachmentSaveName'
        : 'hcPostcareAttachmentSaveName',
      filePathField: isCheckup
        ? 'hcCheckupAttachmentFilePath'
        : 'hcPostcareAttachmentFilePath',
      previewFilePathField: isCheckup
        ? 'hcCheckupPreviewFilePath'
        : 'hcPostcarePreviewFilePath',
      prefix: isCheckup ? 'hcCheckup' : 'hcPostcare',
    };
  };

  // 파일 타입별 핸들러 함수 반환 헬퍼 함수
  const getFileHandlers = (type) => {
    const isCheckup = type === 'checkup';
    return {
      deleteLogic: isCheckup ? DeleteLogicFileCheckup : DeleteLogicFilePostcare,
      saveLogic: isCheckup ? SaveLogicFileCheckup : SaveLogicFilePostcare,
    };
  };
  //#endregion

  //#region useEffect
  useEffect(() => {
    if (props.filterClick1) {
      gridRef1.current.api &&
        gridRef1.current.api.setQuickFilter(searchInfo.searchText || '');
      props.setFilterClick1(false);
    }
    if (props.saveClick1) {
      Save1();
      props.setSaveClick1(false);
    }
    if (props.printClick1) {
      if (!validateSelection()) {
        props.setPrintClick1(false);
        return;
      }
      PrintLogic1();
      props.setPrintClick1(false);
    }
    if (props.printClick1Guideline) {
      if (!validateSelection()) {
        props.setPrintClick1Guideline(false);
        return;
      }
      PrintGuidelineLogic();
      props.setPrintClick1Guideline(false);
    }
  }, [
    props.filterClick1,
    props.saveClick1,
    props.printClick1,
    props.printClick1Guideline,
  ]);

  // 검진연도 변경 시 편집 중이던 내용 초기화 (조회는 queryKey 변경으로 자동 수행)
  const prevYearRef1 = useRef(searchInfo.year);
  useEffect(() => {
    if (prevYearRef1.current === searchInfo.year) return;
    prevYearRef1.current = searchInfo.year;
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  }, [searchInfo.year]);
  //#endregion

  //#region 쿼리
  // 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(rows);
    },
  });
  const { runAsync: Search2Async } = useSearch2();

  // 삭제
  const delete1 = useDelete1();
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRows,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  // 저장
  const ValidateHcYearLogic = (rows) => {
    const selectedYear = searchInfo.year || dayjs().format('YYYY');
    const mismatchRows = rows.filter(
      (r) =>
        r.hcDate &&
        dayjs(r.hcDate).isValid() &&
        dayjs(r.hcDate).format('YYYY') !== selectedYear
    );
    if (mismatchRows.length === 0) return true;

    const names = mismatchRows
      .map((r) => r.name)
      .filter(Boolean)
      .slice(0, 3)
      .join(', ');
    dispatch(
      showSnackbar({
        message: `검진일이 ${selectedYear}년이 아닌 행이 있습니다.${names ? ` (${names}${mismatchRows.length > 3 ? ' 외' : ''})` : ''} 검진연도를 변경하거나 검진일을 확인해 주세요.`,
        type: 'warning',
      })
    );
    return false;
  };

  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel:
      '성명, 검진주기(년), 검진일, 유효일자, 알람여부, 검진기관, 검진표 첨부, 사후관리조치 첨부',
    schema: HEA_BASIC_01_Schema,
    getChangedRows: () => {
      const rows = changedRowData1.filter((r) => !r.deleteYn);
      if (!ValidateHcYearLogic(rows)) return false;
      return rows;
    },
    getDeletedRows: () => deletedRows,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: async (rows) => {
      // 1. 알람 처리 (Save2Async)
      const rowsWithAlarm = await Promise.all(
        rows.map(async (item) => {
          let alarmId = 0;
          try {
            // 캘린더 정보 조회
            const calendarData = await Search2Async();
            if (calendarData && calendarData.length > 0) {
              // mainCalendar = 'Y'인 것의 calId 찾기
              const mainCalendar = calendarData.find(
                (cal) => cal.mainCalendar === 'Y'
              );
              const calId = mainCalendar?.calId || null;
              if (calId) {
                // 알람 생성/삭제 처리
                const alarmResult = await Save2Async([{ ...item, calId }]);
                const alarmData = alarmResult?.data || [];
                if (alarmData && alarmData.length > 0) {
                  alarmId = alarmData[0]?.alarmId || null;
                }
              }
            }
          } catch (error) {
            console.error('알람 처리 중 오류:', error);
            // 알람 처리 실패해도 저장은 진행
          }
          return { ...item, alarmId };
        })
      );
      // 2. 저장 (Save1Async)
      return Save1Async(rowsWithAlarm);
    },
    fileDelete: async (deletedRows) => {
      // 삭제된 행들에 대해 파일 삭제 처리
      for (const item of deletedRows) {
        const fileTypes = [
          {
            type: 'checkup',
            oldFilePath: item.hcCheckupAttachmentFilePath || '',
          },
          {
            type: 'postcare',
            oldFilePath: item.hcPostcareAttachmentFilePath || '',
          },
        ];
        for (const fileType of fileTypes) {
          // 파일이 삭제된 경우
          if (fileType.oldFilePath) {
            const { deleteLogic } = getFileHandlers(fileType.type);
            await deleteLogic(fileType.oldFilePath);
          }
        }
      }
    },
    fileSave: async (changedRows) => {
      // 저장된 행들에 대해 파일 저장 처리
      for (const item of changedRows) {
        // 파일 처리 - 배열로 구성
        const fileTypes = [
          {
            type: 'checkup',
            fileName: item.hcCheckupAttachmentSaveName || '',
            oldFilePath: item.hcCheckupAttachmentFilePath || '',
            previewFilePath: item.hcCheckupPreviewFilePath || '',
          },
          {
            type: 'postcare',
            fileName: item.hcPostcareAttachmentSaveName || '',
            oldFilePath: item.hcPostcareAttachmentFilePath || '',
            previewFilePath: item.hcPostcarePreviewFilePath || '',
          },
        ];
        for (const fileType of fileTypes) {
          if (fileType.previewFilePath && fileType.fileName) {
            // 새 파일이 업로드된 경우
            const { prefix } = getFileFields(
              fileType.type === 'checkup' ? 'hcCheckupFile' : 'hcPostcareFile'
            );
            const { deleteLogic, saveLogic } = getFileHandlers(fileType.type);
            const fileData = {
              ...item,
              [`${prefix}AttachmentSaveName`]: fileType.fileName,
              [`${prefix}AttachmentFilePath`]: fileType.oldFilePath,
              previewFilePath: fileType.previewFilePath,
            };
            await deleteLogic(fileType.oldFilePath);
            await saveLogic(fileData, searchInfo.custCd);
          }
        }
      }
    },
    onSuccessRefresh: () => SearchLogic1(),
    partialRefresh: async ({ saveResult, changedRows }) => {
      await handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: SearchLogic1,
      });
    },
  });

  const ResetLogic = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };

  const SearchLogic1 = async () => {
    ResetLogic();
    if (!validateSelection()) return;
    await Search1();
  };
  //#endregion

  //#region 나머지 함수
  const DownloadLogic1 = async () => {
    try {
      let filePath = '';
      let fileName = previewFileName || 'downloaded_file';

      if (previewUrl) {
        if (previewUrl.startsWith('data:')) {
          const a = document.createElement('a');
          a.href = previewUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 완료`,
              type: 'success',
            })
          );
          return;
        }
        filePath = previewUrl.includes(Global.file.useUrl + 'files/')
          ? decodeURIComponent(
            previewUrl.replace(Global.file.useUrl + 'files/', '')
          )
          : previewUrl;
      } else {
        const rowData = selectedRowData1?.[0];
        if (!rowData) {
          dispatch(
            showSnackbar({
              message: '파일이 존재하지 않습니다.',
              type: 'warning',
            })
          );
          return;
        }
        const { filePathField, fileNameField, previewFilePathField } =
          getFileFields(currentFileFieldType);
        filePath =
          rowData[previewFilePathField] || rowData[filePathField] || '';
        fileName = rowData[fileNameField] || fileName;
        if (!filePath) {
          dispatch(
            showSnackbar({
              message: '파일이 존재하지 않습니다.',
              type: 'warning',
            })
          );
          return;
        }
      }

      const finalFileName =
        fileName === 'downloaded_file'
          ? decodeURIComponent(filePath.split('/').pop() || fileName)
          : fileName;

      const result = await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        { FileName: finalFileName, Url: Commons.EncodeUrl(filePath) }
      );

      if (!result?.data || !result?.headers?.['content-type']) {
        dispatch(
          showSnackbar({
            message: `"${finalFileName}" 다운로드 응답이 비정상입니다.`,
            type: 'error',
          })
        );
        return;
      }

      const blob = new Blob([result.data], {
        type: result.headers['content-type'],
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = finalFileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch(
        showSnackbar({
          message: `"${finalFileName}" 다운로드 완료`,
          type: 'success',
        })
      );
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
    }
  };

  // 인쇄 함수
  const PrintLogic1 = useCallback(async () => {
    // 데이터 확인
    const currentRowData = rowData1.filter((row) => !row.deleteYn);
    if (currentRowData.length === 0) {
      dispatch(
        showSnackbar({
          message: '인쇄할 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    dispatch(showLoadingAction());

    try {
      // 사업장명 가져오기
      const custNm =
        searchInfo.custList?.find((item) => item.value === searchInfo.custCd)
          ?.name || '';

      // HeaderData 설정
      const headerData = {
        custNm: custNm, // 사업장명
        createDate: dayjs().format('YYYY-MM-DD'), // 작성일자
        userNm: userInfo.userNm || '', // 사용자명
      };

      // TableData 매핑 (레포트 양식에 맞게) - 최신 rowData1 사용
      const tableData = currentRowData.map((row, index) => {
        // 검진일 포맷팅
        const checkupDate = row.hcDate
          ? dayjs(row.hcDate).format('YYYY-MM-DD')
          : '';

        // 유효일자 포맷팅
        const effeDate = row.hcEffeDate
          ? dayjs(row.hcEffeDate).format('YYYY-MM-DD')
          : '';

        return {
          no: index + 1,
          depNm1: row.depNm1 || '', // 본부
          depNm2: row.depNm2 || '', // 부서
          depNm3: row.depNm3 || '', // 팀
          depNm4: row.depNm4 || '', // 파트
          position: row.position || '', // 직책
          name: row.name || '', // 성명
          hcCycle: row.hcCycle || '', // 검진주기(년)
          hcDate: checkupDate, // 검진일
          hcEffeDate: effeDate, // 유효일자
          hcCheckupCenter: row.hcCheckupCenter || '', // 검진기관
          hcAlarmYn: row.hcAlarmYn || '', // 알람여부(Y/N)
          hcRemark: row.hcRemark || '', // 비고
        };
      });

      const printData = {
        FileName: 'HEA_BASIC_01',
        HeaderData: JSON.stringify(headerData),
        TableData: JSON.stringify(tableData),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoadingAction());
    }
  }, [rowData1, dispatch, searchInfo, userInfo.userNm]);

  // 건강진단 실시 지침서 인쇄 함수
  const PrintGuidelineLogic = useCallback(async () => {
    dispatch(showLoadingAction());
    try {
      const printData = {
        FileName: 'HEA_BASIC',
        HeaderData: JSON.stringify({}),
      };
      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoadingAction());
    }
  }, [dispatch]);

  const PopupFileClickEvent = async (rowData, fieldType) => {
    setCurrentFileFieldType(fieldType);
    const { previewFilePathField, fileNameField, filePathField } =
      getFileFields(fieldType);
    const newPreviewPath = rowData[previewFilePathField] || '';
    const newFileName = rowData[fileNameField] || '';
    const existingFilePath = rowData[filePathField] || '';
    const existingFileName = rowData[fileNameField] || '';
    const fileName = newFileName || existingFileName;
    let previewUrl = '';
    if (newPreviewPath) {
      const fixedPath = Commons.EncodeUrl(newPreviewPath);
      previewUrl = fixedPath ? Global.file.useUrl + 'files/' + fixedPath : '';
    } else if (existingFilePath) {
      const fixedPath = Commons.EncodeUrl(existingFilePath);
      previewUrl = fixedPath ? Global.file.useUrl + 'files/' + fixedPath : '';
    }
    dispatch(
      setFileFields({
        previewFilePathField,
        previewFileName: fileName || '파일 선택',
        previewUrl,
      })
    );
    setTimeout(() => setFileModalToggle(true), 100);
  };

  const PopupClickEvent1 = (e) => {
    rowClickData.current = {
      rowIndex: e.rowIndex,
      data: e.data,
    };
    setModalToggle1(true);
  };

  const updateGridRow = (rowNode, selected) => {
    const updatedData = {
      ...rowNode.data,
      hcId: selected.id,
      name: selected.name,
      depNm1: selected.depNm1,
      depNm2: selected.depNm2,
      depNm3: selected.depNm3,
      depNm4: selected.depNm4,
      position: selected.position,
      employeeNo: selected.employeeNo,
      editYn: 'Y',
    };
    rowNode.setData(updatedData);
    setChangedRowData1((prev) => {
      const filtered = prev.filter((row) => row.no !== updatedData.no);
      return [...filtered, updatedData];
    });
    const api = gridRef1.current?.api;
    if (api) {
      api.setFocusedCell(rowNode.rowIndex, 'name');
      api.startEditingCell({ rowIndex: rowNode.rowIndex, colKey: 'name' });
    }
  };

  /** 회원 1명분 신규 행 데이터 */
  const CreateNewRowData = (member) => {
    return {
      no: uuidv4(),
      hcCd: '',
      custCd: searchInfo.custCd || '',
      hcGubun: '일반',
      newYn: 'Y',
      hcId: member.id,
      name: member.name,
      depNm1: member.depNm1,
      depNm2: member.depNm2,
      depNm3: member.depNm3,
      depNm4: member.depNm4,
      position: member.position,
      employeeNo: member.employeeNo,
      hcCycle: '1',
      hcDate: '',
      hcEffeDate: '',
      hcAlarmYn: 'Y',
      hcCheckupCenter: '',
      hcCheckupAttachmentFileName: '',
      hcCheckupAttachmentSaveName: '',
      hcCheckupAttachmentFilePath: '',
      hcPostcareAttachmentFileName: '',
      hcPostcareAttachmentSaveName: '',
      hcPostcareAttachmentFilePath: '',
      hcRemark: '',
      alarmId: '',
    };
  };

  const HandleManageSelection = (selected) => {
    if (selected == null) return;
    if (!selected.length) return;

    const api = gridRef1.current?.api;
    if (!api) return;

    let membersToAdd = [...selected];
    const clickCtx = rowClickData.current;

    if (clickCtx?.data?.no != null) {
      const existingNode = api.getRowNode(clickCtx.data.no);
      if (existingNode && membersToAdd.length) {
        updateGridRow(existingNode, membersToAdd[0]);
        membersToAdd = membersToAdd.slice(1);
      }
      rowClickData.current = null;
    }

    if (!membersToAdd.length) return;

    const rowsToAdd = membersToAdd.map((member) => CreateNewRowData(member));

    api.applyTransaction({ add: rowsToAdd, addIndex: 0 });
    setChangedRowData1((prev) => [...rowsToAdd, ...prev]);

    setTimeout(() => {
      api.deselectAll();
      rowsToAdd.forEach((rowData) => {
        api.getRowNode(rowData.no)?.setSelected(true, true);
      });
      const last = rowsToAdd[rowsToAdd.length - 1];
      const lastNode = api.getRowNode(last.no);
      if (lastNode) {
        api.ensureIndexVisible(lastNode.rowIndex, 'middle');
        api.setFocusedCell(lastNode.rowIndex, 'name');
        api.startEditingCell({ rowIndex: lastNode.rowIndex, colKey: 'name' });
      }
    }, 0);
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  // 엑셀 업로드
  const ExcelUpload1 = async (file) => {
    try {
      dispatch(showLoadingAction());

      const arrayBuffer = await file.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      const worksheet = workbook.worksheets[0];
      if (!worksheet) {
        dispatch(
          showSnackbar({
            message: '엑셀 시트를 불러오지 못했습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoadingAction());
        return;
      }

      // 6행부터 데이터 읽기
      const startRow = 6;
      const columnKeys = [
        'depNm1',
        'depNm2',
        'depNm3',
        'depNm4',
        'position',
        'name',
        'employeeNo',
        'hcCycle',
        'hcDate',
        'hcEffeDate',
        'hcAlarmYn',
        'hcCheckupCenter',
        'hcRemark',
      ];

      const uploadedData = [];
      let currentRow = startRow;
      let hasData = true;

      while (hasData) {
        const row = worksheet.getRow(currentRow);
        const rowData = {};

        // 첫 번째 컬럼(성명)이 비어있으면 데이터가 없는 것으로 간주
        const firstCellValue = row.getCell(1).value;
        if (!firstCellValue || firstCellValue.toString().trim() === '') {
          hasData = false;
          break;
        }

        columnKeys.forEach((key, index) => {
          const cell = row.getCell(index + 1);
          let value = cell.value;

          if (value === null || value === undefined) {
            value = '';
          } else {
            if (key === 'hcDate' || key === 'hcEffeDate') {
              if (value instanceof Date) {
                value = value.toISOString();
              } else if (typeof value === 'number') {
                const excelDate = new Date((value - 25569) * 86400 * 1000);
                value = excelDate.toISOString();
              } else {
                value = value.toString().trim();
              }
            } else {
              if (typeof value === 'object' && value !== null) {
                value =
                  Array.isArray(value.richText) && value.richText.length > 0
                    ? value.richText.map((item) => item?.text || '').join('')
                    : value.toString().trim();
              } else {
                value = value.toString().trim();
              }
            }
          }

          rowData[key] = value;
        });

        if (rowData.name) {
          rowData.newYn = 'Y';
          rowData.no = `new_${Date.now()}_${currentRow}`;
          rowData.hcId = companyInfo[0].properName + rowData.employeeNo;
          uploadedData.push(rowData);
        }

        currentRow++;
        if (currentRow > startRow + 1000) {
          break;
        }
      }

      if (uploadedData.length === 0) {
        dispatch(
          showSnackbar({
            message: '읽을 수 있는 데이터가 없습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoadingAction());
        return;
      }

      // 엑셀 업로드 키: 본부, 부서, 팀, 파트, 직책, 성명
      const makeKeyString = (item) => {
        const depNm1 = item.depNm1 != null ? String(item.depNm1).trim() : '';
        const depNm2 = item.depNm2 != null ? String(item.depNm2).trim() : '';
        const depNm3 = item.depNm3 != null ? String(item.depNm3).trim() : '';
        const depNm4 = item.depNm4 != null ? String(item.depNm4).trim() : '';
        const position =
          item.position != null ? String(item.position).trim() : '';
        const name = item.name != null ? String(item.name).trim() : '';
        return `${depNm1}|${depNm2}|${depNm3}|${depNm4}|${position}|${name}`;
      };

      const existingDataMap = new Map();
      rowData1.forEach((row) => {
        if (!row.deleteYn) {
          const key = makeKeyString(row);
          if (key && key !== '|||||') existingDataMap.set(key, row);
        }
      });

      const excelKeySet = new Set();
      uploadedData.forEach((row) => {
        const key = makeKeyString(row);
        if (key && key !== '|||||') excelKeySet.add(key);
      });

      const hasChanges = (existingRow, excelRow) => {
        const fieldsToCompare = columnKeys.filter((k) => k !== 'name');
        for (const field of fieldsToCompare) {
          let existingValue = existingRow[field];
          let excelValue = excelRow[field];

          if (field === 'hcDate' || field === 'hcEffeDate') {
            if (existingValue) {
              const d = dayjs(existingValue);
              existingValue = d.isValid()
                ? d.format('YYYY-MM-DD')
                : String(existingValue || '').trim();
            } else {
              existingValue = '';
            }
            if (excelValue) {
              const d = dayjs(excelValue);
              excelValue = d.isValid()
                ? d.format('YYYY-MM-DD')
                : String(excelValue || '').trim();
            } else {
              excelValue = '';
            }
          } else {
            existingValue =
              existingValue !== null && existingValue !== undefined
                ? String(existingValue).trim()
                : '';
            excelValue =
              excelValue !== null && excelValue !== undefined
                ? String(excelValue).trim()
                : '';
          }

          if (existingValue !== excelValue) {
            return true;
          }
        }
        return false;
      };

      const newRows = [];
      const updatedRows = [];
      const updatedKeys = new Set();

      for (const excelRow of uploadedData) {
        const key = makeKeyString(excelRow);
        if (!key || key === '|||||') continue; // 본부~성명 모두 비어있으면 스킵

        if (existingDataMap.has(key)) {
          const existingRow = existingDataMap.get(key);
          if (hasChanges(existingRow, excelRow)) {
            const updatedRow = {
              ...existingRow,
              ...excelRow,
              editYn: 'Y',
              no: existingRow.no,
              hcCd: existingRow.hcCd || '',
            };
            updatedRows.push(updatedRow);
            updatedKeys.add(key);
          }
        } else {
          newRows.push({
            ...excelRow,
            newYn: 'Y',
            no: `new_${Date.now()}_${Math.random()}`,
          });
        }
      }

      const rowsToDelete = [];
      rowData1.forEach((row) => {
        if (!row.deleteYn) {
          const key = makeKeyString(row);
          if (
            key &&
            key !== '|||||' &&
            !excelKeySet.has(key) &&
            row.deleteYn !== 'Y'
          ) {
            rowsToDelete.push({
              ...row,
              deleteYn: 'Y',
            });
          }
        }
      });

      const updatedRowData = rowData1.map((row) => {
        if (row.deleteYn) return row;
        const key = makeKeyString(row);
        if (key && updatedKeys.has(key)) {
          const updatedRow = updatedRows.find(
            (ur) => makeKeyString(ur) === key
          );
          if (updatedRow) return updatedRow;
        }
        if (rowsToDelete.some((rd) => rd.no === row.no)) {
          return { ...row, deleteYn: 'Y' };
        }
        return row;
      });

      const finalRowData = [...updatedRowData, ...newRows];
      setRowData1(finalRowData);
      gridRef1.current.api.setRowData(finalRowData);

      const changedData = [...updatedRows, ...newRows];
      setChangedRowData1(changedData);

      if (rowsToDelete.length > 0) {
        setDeletedRowData1((prev) => {
          const existingDeleted = prev || [];
          const newDeleted = rowsToDelete.filter(
            (rd) => !existingDeleted.some((ed) => ed.no === rd.no)
          );
          return [...existingDeleted, ...newDeleted];
        });
      }

      dispatch(
        showSnackbar({
          message: '엑셀 업로드가 완료되었습니다.',
          type: 'success',
        })
      );
    } catch (error) {
      console.error('Excel upload error:', error);
      dispatch(
        showSnackbar({
          message: `엑셀 업로드 중 오류가 발생했습니다: ${error.message}`,
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoadingAction());
    }
  };

  // 엑셀 다운로드
  const ExcelDownload1 = async () => {
    try {
      dispatch(showLoadingAction());

      const workbook = new ExcelJS.Workbook();
      const templateUrl = getTemplatePath();

      const response = await fetch(templateUrl);
      const arrayBuffer = await response.arrayBuffer();
      await workbook.xlsx.load(arrayBuffer);

      const worksheet = workbook.worksheets[0];
      if (!worksheet) {
        dispatch(
          showSnackbar({
            message: '템플릿 시트를 불러오지 못했습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoadingAction());
        return false;
      }

      const detailData = rowData1.filter((r) => !r.deleteYn);
      const startRow = 6;
      const columnKeys = [
        'depNm1',
        'depNm2',
        'depNm3',
        'depNm4',
        'position',
        'name',
        'employeeNo',
        'hcCycle',
        'hcDate',
        'hcEffeDate',
        'hcAlarmYn',
        'hcCheckupCenter',
        'hcRemark',
      ];

      detailData.forEach((item, index) => {
        const row = worksheet.getRow(startRow + index);
        columnKeys.forEach((key, i) => {
          const cell = row.getCell(i + 1);

          let value = item[key];

          if (key === 'hcDate' || key === 'hcEffeDate') {
            if (value) {
              const date = dayjs(value);
              value = date.isValid() ? date.format('YYYY-MM-DD') : '';
            } else {
              value = '';
            }
            cell.numFmt = '@';
          } else {
            value = value || '';
          }

          setPreserveStyle(cell, value);

          cell.font = { name: 'Arial', size: 10 };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
            wrapText: false,
          };
          cell.border = {
            top: { style: 'thin', color: { argb: 'FF808080' } },
            left: { style: 'thin', color: { argb: 'FF808080' } },
            bottom: { style: 'thin', color: { argb: 'FF808080' } },
            right: { style: 'thin', color: { argb: 'FF808080' } },
          };
        });
        row.commit();
      });

      const maxDataRow = Math.max(startRow + detailData.length, startRow + 200);
      const endRow = maxDataRow;

      // 알람여부 컬럼 드롭다운
      const alarmYnColIndex = columnKeys.indexOf('hcAlarmYn');
      if (alarmYnColIndex !== -1) {
        const alarmYnCol = String.fromCharCode(65 + alarmYnColIndex);
        worksheet.dataValidations.add(
          `${alarmYnCol}${startRow}:${alarmYnCol}${endRow}`,
          {
            type: 'list',
            allowBlank: true,
            formulae: ['"Y,N"'],
            showErrorMessage: true,
            errorStyle: 'error',
            errorTitle: '입력 오류',
            error: 'Y 또는 N만 입력 가능합니다.',
          }
        );
      }

      // 검진주기 컬럼 드롭다운 (1, 2)
      const hcCycleColIndex = columnKeys.indexOf('hcCycle');
      if (hcCycleColIndex !== -1) {
        const hcCycleCol = String.fromCharCode(65 + hcCycleColIndex);
        worksheet.dataValidations.add(
          `${hcCycleCol}${startRow}:${hcCycleCol}${endRow}`,
          {
            type: 'list',
            allowBlank: true,
            formulae: ['"1,2"'],
            showErrorMessage: true,
            errorStyle: 'error',
            errorTitle: '입력 오류',
            error: '1 또는 2만 입력 가능합니다.',
          }
        );
      }

      // 직책 컬럼 드롭다운 (9종)
      const positionColIndex = columnKeys.indexOf('position');
      if (positionColIndex !== -1) {
        const positionCol = String.fromCharCode(65 + positionColIndex);
        const positionList =
          '사업주,안전관리자,보건관리자,관리감독자,산업보건의,안전보건관리담당자,안전보건총괄책임자,안전보건관리책임자,명예산업안전감독관';
        worksheet.dataValidations.add(
          `${positionCol}${startRow}:${positionCol}${endRow}`,
          {
            type: 'list',
            allowBlank: true,
            formulae: [`"${positionList}"`],
            showErrorMessage: true,
            errorStyle: 'error',
            errorTitle: '입력 오류',
            error: '직책 목록에서 선택해주세요.',
          }
        );
      }

      // 날짜 컬럼 YYYY-MM-DD 형식 검증
      const dateFields = ['hcDate', 'hcEffeDate'];
      dateFields.forEach((dateField) => {
        const dateFieldColIndex = columnKeys.indexOf(dateField);
        if (dateFieldColIndex !== -1) {
          const colNumber = dateFieldColIndex + 1;
          const column = worksheet.getColumn(colNumber);
          column.numFmt = '@';

          const dateFieldCol = column.letter;
          worksheet.dataValidations.add(
            `${dateFieldCol}${startRow}:${dateFieldCol}${endRow}`,
            {
              type: 'custom',
              allowBlank: true,
              formulae: [
                `OR(${dateFieldCol}${startRow}="", AND(LEN(${dateFieldCol}${startRow})=10, MID(${dateFieldCol}${startRow},5,1)="-", MID(${dateFieldCol}${startRow},8,1)="-"))`,
              ],
              showErrorMessage: true,
              errorStyle: 'error',
              errorTitle: '입력 오류',
              error:
                '날짜는 YYYY-MM-DD 형식으로 입력해주세요. (예: 2025-01-15)',
            }
          );
        }
      });

      const dateTimeStr = getCurrentFormattedDateTime('file');
      const methodName = `일반건강진단_${dateTimeStr}.xlsx`;

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = methodName;
      link.click();

      dispatch(closeLoadingAction());
    } catch (error) {
      console.error('Excel download error:', error);
      dispatch(
        showSnackbar({
          message: `엑셀 다운로드 중 오류가 발생했습니다: ${error.message}`,
          type: 'error',
        })
      );
      dispatch(closeLoadingAction());
    }
  };

  // 스타일 유지하며 값만 교체
  function setPreserveStyle(cell, value) {
    if (!cell) return;
    const { font, alignment, border, fill, numFmt } = cell;
    cell.value = value;
    cell.style = { font, alignment, border, fill, numFmt };
  }

  // 템플릿 경로 가져오기
  function getTemplatePath() {
    const base = `${Global.file.useUrl}files/ExcellExportFrom/HealthCheckup/`;
    return base + '일반건강진단.xlsx';
  }

  // 현재 날짜와 시간 포맷
  function getCurrentFormattedDateTime(_type) {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    if (_type === 'data') {
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } else if (_type === 'file') {
      return `${year}${month}${day}_${hours}${minutes}${seconds}`;
    }
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  //#endregion

  return (
    <div className="wrap">
      <HEA_BASIC_01
        gridId1={'grid1'}
        navigate={navigate}
        userInfo={userInfo}
        rowData1={rowData1}
        lanInfo={lanInfo}
        gridRef1={gridRef1}
        gridRef3={gridRef3}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        deletedRowData1={deletedRows}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        rowClickData={rowClickData}
        excelData={excelData}
        setExcelData={setExcelData}
        fileInputRef={fileInputRef}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        searchInfo={searchInfo}
        ResetLogic1={ResetLogic}
        SearchLogic1={SearchLogic1}
        PopupClickEvent1={PopupClickEvent1}
        SaveLogic1={Save1}
        DownloadLogic1={DownloadLogic1}
        NewYnErrorMsg={NewYnErrorMsg}
        handleRowSelection1={handleRowSelection1}
        RestoreRow1={deleteHandler1.RestoreRow}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        HandleManageSelection={HandleManageSelection}
        fileModalToggle={fileModalToggle}
        currentFileFieldType={currentFileFieldType}
        setCurrentFileFieldType={setCurrentFileFieldType}
        setFileModalToggle={setFileModalToggle}
        PopupFileClickEvent={PopupFileClickEvent}
        SaveLogicPreview={SaveLogicPreview}
        DeleteLogicFile={DeleteLogicFile}
        ExcelUpload1={ExcelUpload1}
        ExcelDownload1={ExcelDownload1}
      />
      <MemberInfoModal
        open={modalToggle1}
        onClose={() => setModalToggle1(false)}
        onSelection={HandleManageSelection}
        multiYn="Y"
      />
    </div>
  );
}

export default HEA_BASIC_01F;
